import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import {set_girl_fav, get_girl_memo, set_girl_memo} from '../actions'
import {LoginOrRegister} from './loginorregister.react.js'
import {MemoForm} from './memo.react.js'

import * as utils from '../utils.js'

const Schedule = ({f, t}) => {
  const mm = f.getMonth()+1,
        dd = f.getDate(),
        ww = utils.weekday[f.getDay()],
        hh1 = utils.zfill(f.getHours(), 2),
        mm1 = utils.zfill(f.getMinutes(), 2),
        hh2 = utils.zfill(t.getHours(), 2),
        mm2 = utils.zfill(t.getMinutes(), 2),
        now = new Date(),
        working = (f <= now ) && (now < t);

  return (
    <div className={classNames({'working': working})}>
      {`${mm}/${dd}(${ww}) ${hh1}:${mm1} 〜 ${hh2}:${mm2}`}
    </div>
  )
}

const girlInfoMapStateToProps = (state) => {
  return {
  }
}

const girlInfoMapDispatchToProps = {
  set_girl_fav, set_girl_memo, get_girl_memo
}

const GirlInfo = connect(girlInfoMapStateToProps, girlInfoMapDispatchToProps)(React.createClass({

  getInitialState: function() {
    return {
      showLoginOrRegister: false,
      formCaption: '',
      showMemo: false
    }
  },

  toggleGirlFav: function(e) {
    e.preventDefault()
    if (window.show_user) {
      this.props.set_girl_fav(this.props.shop, this.props.girl, !this.props.girl.fav);
    }
    else {
      this.setState({
        showLoginOrRegister: true,
        formCaption: 'オキニ登録にはユーザ登録が必要です'
      })
    }
  },

  showMemo(e) {
    e.preventDefault()

    if (window.show_user) {
      this.props.get_girl_memo(this.props.shop, this.props.girl)
        .then(ret=>{
          this.setState({showMemo: true})
        })
    }
    else {
      this.setState({
        showLoginOrRegister: true,
        formCaption: 'メモ登録にはユーザ登録が必要です'
      })
    }
  },

  closeForm(e) {
    this.setState({
      showLoginOrRegister: false,
    })
  },

  closeMemo(e) {
    console
    this.setState({showMemo: false})
  },

  saveMemo(memo) {
    return this.props.set_girl_memo(this.props.shop, this.props.girl, memo)
  },

  render: function () {
    const girl = this.props.girl
    const shop = this.props.shop
    const has_schedules = girl.schedules.length != 0

    return (
      <div className={classNames('girlcell', {girlcell_noschedule:!has_schedules})}>
        <LoginOrRegister showModal={this.state.showLoginOrRegister} formCaption={this.state.formCaption}
          close={this.closeForm}/>
        <MemoForm shop={shop} memo={girl.memotext} showModal={this.state.showMemo} close={this.closeMemo}
        save_memo={this.saveMemo}
        title={"女の子メモ"}/>

        <div className="panel panel-info">
          <div className='panel-heading'>
            <a className={classNames('girl-favbutton', 'fa' , {'fa-heart': girl.fav, 'fa-heart-o': !girl.fav})}
                title='お気に入りに登録' href='#'
                onClick={this.toggleGirlFav}><span className='okini-button'>オキニ</span></a>&nbsp;
            <a target='_blank' href={girl.url} className='girlname'>{girl.name} ({girl.age})</a>&nbsp;
            &nbsp;
            <a
              className={classNames('girl-memobutton', 'fa' , 'fa-edit', {'usermemo': girl.memo})}
             title='メモ'
              href='#' onClick={this.showMemo}><span className='okini-button'>メモ</span></a>
          </div>

          <div className='panel-body'>
            <div className='girl-boxrow clearfix'>
              <div className='girl-profile'>
                <div>
                  <a target='_blank' href={girl.url}>
                    <img src={girl.avator_url} style={{width:'90px'}}/>
                  </a>
                </div>
              </div>

              <div className='girl-workdays clearfix'>
                { girl.schedules.map(([f, t], index)=>(
                  <Schedule f={f} t={t} key={index} />
                ))}
              </div>
            </div>

            <div className='girl-spec'> T.{girl.height} B.{girl.b}({girl.cup}) W{girl.w} H{girl.h}
            <br/>{girl.memid?girl.memid : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}))

const mapStateToProps = (state, {shop}) => {
  var girls = state.girls[shop.id]
  return {
    girls
  }
}

const mapDispatchToProps = {
}

const GirlList = React.createClass({
  render: function () {
    if (!this.props.girls) {
      return (<div className="loading">
        ロードしています
      </div>)
    }
    else if (this.props.girls.length == 0) {
      return (<div className="loading">
        データがありません
      </div>)
    }

    return (
      <div className="clearfix girllist">
        { this.props.girls.map((girl)=>(
          (<GirlInfo girl={girl} shop={this.props.shop} key={girl.id}/>)
        ))}
      </div>
    )
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(GirlList)



// WEBPACK FOOTER //
// ./components/girllist.react.js